import { Injector, OnInit } from "@angular/core";
import { BaseComponent } from "./base-component";
import { ActivatedRoute } from "@angular/router";
import { Observable, of } from 'rxjs';
import { AEntity } from "../models/a-entity";
import { CrudService } from "../services/crud.service";
import { UniqueIdConfig } from "../directives/unique-id-validate.directive";

export abstract class EditComponent<T extends AEntity, U extends CrudService<T>> extends BaseComponent implements OnInit {
    protected _service: U;
    model: T;
    uniqueCode: UniqueIdConfig;

    protected _activatedRoute: ActivatedRoute;
    protected _baseUrl: string;

    /**
     * Create a global class to manage list component actions
     * @param injector - injector root service used in app.module
     */
    constructor(modelType: { new(): T; }, serviceType: { new(Injector): U; }, injector: Injector, baseUrl: string, dataProperty: string = undefined, uniqueCodeProperty: string = 'code') {
        super(injector);

        this._activatedRoute = injector.get(ActivatedRoute);
        this.model = new modelType();
        this._service = new serviceType(injector);

        this.uniqueCode = new UniqueIdConfig();
        this.uniqueCode.source = this._authService.data[dataProperty];
        this.uniqueCode.key = uniqueCodeProperty;

        if (baseUrl) {
            this._baseUrl = baseUrl;
            if (!this._baseUrl.startsWith('/')) this._baseUrl = '/' + this._baseUrl;
            if (!this._baseUrl.endsWith('/')) this._baseUrl += '/';
        }
    }

    ngOnInit(): void {
        this._activatedRoute.params.subscribe(params => this.load(params.id));
    }

    protected load(id: number): void {
        this.loadModel(id).subscribe(res => {
            this.model = res;
            this.uniqueCode.excludeValue = res.id;
        });
    }

    protected loadModel(id: number): Observable<T> {
        let res: Observable<T>;

        if (id > 0) res = this._service.readOne(id);
        else res = of<T>(this.model);

        return res;
    }

    cancel() {
        this.navigate(this._baseUrl);
    }

    protected internalSave(): Observable<T> {
        var res: Observable<T>;

        if (this.model.id > 0) res = this._service.updateOne(this.model);
        else res = this._service.createOne(this.model);

        return res;
    }

    canSave(model: T): boolean {
        if (model && model.id > 0) return this._authService.hasRight(this.structurePath + '/update');
        else return true;
    }
    save() {
        this.internalSave().subscribe((res) => this.cancel(), (err) => this._service.displayError(err));
    }
}
